import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import CardsComponent from './cards';
import CategoriesComponent from './categories';
import Matrix from './matrix';
import SimilarityMatrix from './similarity-matrix';
import Dendrogram from './dendrogram';

import {
  Container,
  TabMenu,
} from './styles';

const TAB_NAME = {
  cards: 'Cards',
  categories: 'Categories',
  matrix: 'Matrix',
  mergedMatrix: 'Merged Matrix',
  similarityMatrix: 'Similarity Matrix',
  dendrogram: 'Dendrogram',
};

const CardSortAnalytics = (props) => {
  const {
    project,
    analyticsCardSort,
    segmentId,
    activeTab,
    onChangeTab,
  } = props;

  const normalizedAnalytics = useMemo(() => _.map(analyticsCardSort, (item) => {
    if (item.cardSortMergedCategory) {
      return {
        ...item,
        cardSortCategory: item.cardSortMergedCategory,
      };
    }
    return item;
  }), [analyticsCardSort]);

  const TAB_ITEMS = [
    {
      menuItem: TAB_NAME.cards,
      render: () => (
        <CardsComponent
          analyticsCardSort={normalizedAnalytics}
        />
      ),
    },
    {
      menuItem: TAB_NAME.categories,
      render: () => (
        <CategoriesComponent
          project={project}
          analyticsCardSort={normalizedAnalytics}
        />
      ),
    },
    {
      menuItem: project.cardSortType === 'closed' ? TAB_NAME.matrix : TAB_NAME.mergedMatrix,
      render: () => (
        <Matrix
          analyticsCardSort={normalizedAnalytics}
        />
      ),
    },
    {
      menuItem: TAB_NAME.similarityMatrix,
      render: () => (
        <SimilarityMatrix
          project={project}
          segmentId={segmentId}
        />
      ),
    },
    {
      menuItem: TAB_NAME.dendrogram,
      render: () => (
        <Dendrogram
          project={project}
          segmentId={segmentId}
        />
      ),
    },
  ];

  return (
    <Container>
      <TabMenu
        menu={{ secondary: true }}
        panes={TAB_ITEMS}
        activeIndex={activeTab}
        onTabChange={onChangeTab}
      />
    </Container>
  );
};

CardSortAnalytics.propTypes = {
  analyticsCardSort: PropTypes.arrayOf(PropTypes.shape({
    cardSortCategories: PropTypes.shape(),
    cardSortItems: PropTypes.shape(),
    frequencyPercentage: PropTypes.number,
    frequencyTotal: PropTypes.number,
  })).isRequired,
  project: PropTypes.oneOfType([PropTypes.shape()]).isRequired,
  segmentId: PropTypes.string,
  activeTab: PropTypes.number,
  onChangeTab: PropTypes.func.isRequired,
};

CardSortAnalytics.defaultProps = {
  segmentId: undefined,
  activeTab: 0,
};

export default CardSortAnalytics;
